import './EndGame.css';
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import {useActions} from "../../../hooks/useActions";
import {sounds} from '../../../sounds/sound';
import {MusicService} from '../../../services/MusicService';
import ServerStateDispatcher from "../../../services/states/ServerStateDispatcher";
import {WsService} from "../../../services/PvP/WsService";
import {config} from "../../../config";
import {useEffect} from "react";

function EndGame() {
    const {phase, endGame, isPvP, game} = useTypedSelector(state => state.game);
    const {user, cpuStory, nutakuBoxes, tutorial} = useTypedSelector(state => state.auth);
    const {
        setCpuStory,
        updateUser,
        setPhase,
        setCpuTable,
        setPlayerTable,
        setPlayerHp,
        setCpuHp,
        setIsPvP,
        setGame,
        setRoute,
        setPlayerTurn,
        setPlayerMulligan,
        setTutorial
    } = useActions();

    let rootClasses = 'endGameContainer';

    let resultClasses = '';
    let gems = 0;
    let divineEssence: null | number = null;
    if (phase === 'end_game' && endGame.winner !== null) {
        rootClasses += ' endGameContainerActive';
        gems = endGame.result.rewards.gems;
        divineEssence = endGame.result.rewards?.divine_essence ?? null;

        // @ts-ignore
        if (endGame.winner === 'cpu' || endGame.winner === false) {
            resultClasses += ' endGameDefeat'
        } else {
            resultClasses += ' endGameWin'
        }
    }

    useEffect(() => {
        if (phase !== 'end_game' || endGame.winner === null) {
            return;
        }

        MusicService.stopBattle();

        // @ts-ignore
        if (endGame.winner === 'cpu' || endGame.winner === false) {
            MusicService.playBattleWin(sounds.battle_lose());
        } else {
            MusicService.playBattleWin(sounds.battle_win());
        }
    }, [phase, endGame.winner]);

    const clearState = function () {
        setPhase(null);
        setCpuTable({0: null, 1: null, 2: null, 3: null, 4: null});
        setPlayerTable({0: null, 1: null, 2: null, 3: null, 4: null});
        setPlayerHp(0);
        setCpuHp(0);
        setIsPvP(false);
        setGame(null);
        setPlayerTurn(0);
        setPlayerMulligan(false);
    }
    let withSeasonPass = null;

    if (!user.premium && endGame?.result?.sesason_pass_bonus !== undefined) {
        withSeasonPass += gems + endGame?.result?.sesason_pass_bonus;
    }

    return (
        <div className={rootClasses}>
            <div className={'endGameResult' + resultClasses}>
                <div className={'endGameReward'}>
                    <div className='endGameRewardGems'>
                        <div className='endGameRewardGemsIcon'></div>
                        <div className='endGameRewardGemsValue'>{gems}</div>
                    </div>
                    {(withSeasonPass !== null) ?
                        <div className={'endGameRewardWithSeasonPass'}> With Season Pass : {withSeasonPass}</div>
                        : <div></div>
                    }
                    {(divineEssence !== null) ?
                        <div className='endGameRewardDivine'>
                            <div className='endGameRewardDivineIcon'></div>
                            <div className='endGameRewardGemsValue'>{divineEssence}</div>
                        </div>
                        : <div></div>
                    }
                </div>

                <div className={'endGameButton'}
                     onClick={async () => {
                         WsService.messageLoop = false;
                         ServerStateDispatcher.stopStackLoop();
                         MusicService.stopBattleWin();
                         const previousLevel = user.level;
                         const updatedUser: any = await updateUser();

                         if (previousLevel === 3 && updatedUser?.level === 4) {
                             setTutorial({
                                 ...tutorial,
                                 step: 'ArenaStart200',
                                 isActive: false,
                             });
                         }

                         if (isPvP === false && game?.cpu_id !== 21) {
                             cpuStory.action = 'after';
                             setCpuStory(cpuStory);
                         }

                         clearState();

                         if (user.level > 3) {
                             let chance = 0;
                             if (nutakuBoxes[3].first_payment) {
                                 chance = 0.40;
                             } else {
                                 chance = 0.01;
                             }

                             // @ts-ignore Loser Offer for nutaku
                             if ((endGame.winner === 'cpu' || endGame.winner === false) && Math.random() < chance && config.isNutaku) {
                                 setRoute('info_banner');
                                 return;
                             }

                             chance = 0.40;
                             if (user.premium) {
                                 chance = 0.01;
                             }
                             // @ts-ignore Loser offer for Others
                             if ((endGame.winner === 'cpu') && Math.random() < chance && !config.isNutaku) {
                                 setRoute('info_banner');
                                 return;
                             }
                         }

                         if (isPvP || game?.cpu_id === 21) {

                             setRoute('arena');
                         } else {
                             setRoute('story');
                         }
                         MusicService.playMenuMusic();
                     }}
                >
                </div>
            </div>

        </div>
    );
}

export default EndGame;
